module.exports = __webpack_public_path__ + "img/video-player/volume-0-393e9092898279709d6ecd9e5cd230e9.svg";